import { render, staticRenderFns } from "./Newcomers.vue?vue&type=template&id=8c0ca5c6&"
import script from "./Newcomers.vue?vue&type=script&lang=ts&"
export * from "./Newcomers.vue?vue&type=script&lang=ts&"
import style0 from "@/style/components/affiliate/affiliates-list.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports